import { useEffect } from "react";

type LegalPageProps = { kind: "privacy" | "terms" };

const sections = {
  privacy: {
    eyebrow: "PRIVACIDADE",
    title: "Política de Privacidade",
    intro:
      "Esta política explica, de forma clara, como o MiBoard trata dados pessoais quando você usa a plataforma.",
    items: [
      ["Dados tratados", "Podemos tratar dados de cadastro, como nome e e-mail, dados de perfil fornecidos por você, informações de assinatura e os conteúdos que você escolhe salvar nos seus painéis."],
      ["Finalidades", "Usamos esses dados para criar e proteger sua conta, disponibilizar os painéis, processar pagamentos, oferecer suporte, prevenir abusos e cumprir obrigações legais."],
      ["Cookies e armazenamento", "Usamos recursos essenciais para manter sua sessão, preferências e funcionamento do editor. Recursos analíticos opcionais só são carregados após o seu consentimento no banner de cookies."],
      ["Compartilhamento", "Dados podem ser tratados por fornecedores necessários à operação, como hospedagem, pagamentos e e-mail, sempre conforme a finalidade do serviço. Não vendemos dados pessoais."],
      ["Segurança e retenção", "Aplicamos medidas técnicas e organizacionais para proteger o acesso às contas. Mantemos os dados pelo período necessário para prestar o serviço, atender obrigações legais e resolver disputas."],
      ["Seus direitos", "Nos termos da LGPD, você pode solicitar confirmação de tratamento, acesso, correção, anonimização, eliminação quando aplicável, informação sobre compartilhamentos e revogação de consentimento."],
      ["Contato", "Para dúvidas ou solicitações sobre privacidade, use o canal de suporte disponibilizado na plataforma. Esta política deve ser atualizada antes do lançamento com a identificação jurídica e o contato do encarregado pelo tratamento de dados."],
    ],
  },
  terms: {
    eyebrow: "TERMOS",
    title: "Termos de Uso",
    intro:
      "Estes termos estabelecem as regras para utilizar o MiBoard e seus recursos de criação, organização e compartilhamento de painéis.",
    items: [
      ["Aceitação", "Ao criar uma conta ou usar o MiBoard, você concorda com estes termos e com a Política de Privacidade."],
      ["Conta e acesso", "Você é responsável por manter suas credenciais protegidas e por informar dados corretos. Podemos suspender contas em caso de uso indevido, fraude ou violação destes termos."],
      ["Conteúdo do usuário", "Você mantém a responsabilidade pelo conteúdo que cria, envia ou compartilha. Não publique material ilícito, que viole direitos de terceiros ou que comprometa a segurança da plataforma."],
      ["Planos e pagamentos", "Recursos pagos, preços, condições e cobranças são apresentados antes da contratação. Pagamentos são processados pelo provedor indicado no checkout."],
      ["Disponibilidade", "Buscamos manter o serviço disponível, mas manutenções, falhas de terceiros ou eventos fora do nosso controle podem causar interrupções temporárias."],
      ["Propriedade intelectual", "O MiBoard, sua marca, interface e código são protegidos por direitos aplicáveis. O uso do serviço não transfere esses direitos a você."],
      ["Alterações", "Podemos atualizar estes termos para refletir mudanças no produto ou na legislação. A versão vigente ficará disponível nesta página."],
      ["Contato", "Para dúvidas sobre estes termos, use o canal de suporte disponibilizado na plataforma."],
    ],
  },
} as const;

export const LegalPage = ({ kind }: LegalPageProps) => {
  const page = sections[kind];

  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    const root = document.getElementById("root");
    const previous = {
      htmlOverflow: html.style.overflow,
      bodyOverflow: body.style.overflow,
      htmlHeight: html.style.height,
      bodyHeight: body.style.height,
      rootHeight: root?.style.height || "",
      rootMinHeight: root?.style.minHeight || "",
    };

    html.style.overflow = "auto";
    body.style.overflow = "auto";
    html.style.height = "auto";
    body.style.height = "auto";
    if (root) {
      root.style.height = "auto";
      root.style.minHeight = "100%";
    }

    return () => {
      html.style.overflow = previous.htmlOverflow;
      body.style.overflow = previous.bodyOverflow;
      html.style.height = previous.htmlHeight;
      body.style.height = previous.bodyHeight;
      if (root) {
        root.style.height = previous.rootHeight;
        root.style.minHeight = previous.rootMinHeight;
      }
    };
  }, []);

  return (
    <main className="miboard-legal-page">
      <header className="miboard-legal-header">
        <a href="/">MiBoard</a>
        <a href="/">Voltar ao início</a>
      </header>
      <article className="miboard-legal-card">
        <p className="miboard-legal-eyebrow">{page.eyebrow}</p>
        <h1>{page.title}</h1>
        <p className="miboard-legal-intro">{page.intro}</p>
        <p className="miboard-legal-date">Última atualização: 2026</p>
        {page.items.map(([title, text]) => (
          <section key={title}>
            <h2>{title}</h2>
            <p>{text}</p>
          </section>
        ))}
      </article>
    </main>
  );
};
